import fp from 'lodash/fp';
import React from 'react';
import { Breadcrumb, BreadcrumbItem, Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { branch, lifecycle, renderNothing, withProps } from 'recompose';
import { bindActionCreators, compose } from '../../../../../node_modules/redux';
import { contentStatus, routes } from '../../../../constants';
import { isBusinessAdmin, mapRecommendedContent } from '../../../../services';
import { businessActions, businessSelector, publicBusinessContentSelector, publicNonCpdContentSelector } from '../../../../state/modules/business';
import { publisherActions } from '../../../../state/modules/publisher';
import { currentUserSelector } from '../../../../state/modules/user/selectors';
import { noCapMap } from '../../../../utils';
import { Icon } from '../../../components';
import ContentTile from '../partials/content-tile';

const BusinessContentHome = ({
  nonCpdContent,
  businessContent,
  mapContent,
  isBusinessAdmin
}) => {
  const allContent = nonCpdContent.concat(businessContent).filter(
    ({ status }) => status === contentStatus.Published.value
  )
  return (
    <div className='base-layout'>
      <section id='header--training' className='layout--header'>
        <Grid>
          <Row className='no-gutter'>
            <Col xs={12} md={7}>
              <Breadcrumb>
                <LinkContainer to={routes.app.dashboard}>
                  <BreadcrumbItem active>
                    Dashboard
                  </BreadcrumbItem>
                </LinkContainer>
                <BreadcrumbItem active>
                  Business Library
                </BreadcrumbItem>
              </Breadcrumb>
              <h1 className='flexbox align-center bottom-gap'>
                Business Library
              </h1>
            </Col>
          </Row>
          {
            fp.isEmpty(allContent) && isBusinessAdmin ?
              <div>
                <h2>Upload professional development content and share it with your business</h2>
                <p>Caddie gives you the power to deliver professional development content and quiz’s to your team so you can track it against their CPD obligations. Upload articles, videos, podcasts, webinars, PDFs here.</p>
              </div> :
              null
          }
          <Row className='no-gutter bottom-gap'>
            <Col xs={6} md={3} className='no-padding'>
              <LinkContainer to={routes.app.library.root} className='large full'>
                <Button >
                  Add and Manage Content <Icon icon='add-large' />
                </Button>
              </LinkContainer>
            </Col>
          </Row>
          {
            noCapMap((chunk, chunkIndex) =>
              <Row key={chunkIndex} className='card-gutter row-slider'>
                {
                  noCapMap((content, index) =>
                    <Col key={index} className='top-gap' xs={12} md={3}>
                      <ContentTile {...content} />
                    </Col>
                  )(chunk)
                }
              </Row>
            )(fp.flow(
              mapContent,
              fp.chunk(4)
            )(allContent))
          }
        </Grid>
      </section>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: currentUserSelector(state),
  business: businessSelector(state),
  publishers: state.publisher.publishers,
  isFetchingPublishers: state.publisher.isFetching,
  nonCpdContent: publicNonCpdContentSelector(state),
  businessContent: publicBusinessContentSelector(state),
  mapContent: mapRecommendedContent(state.industry.cpdCategorys, state.publisher.publishers, businessSelector(state))
});

const mapDispatchToProps = (dispatch) => ({
  getNonCpdContent: bindActionCreators(businessActions.business.content.getNonCpdContent, dispatch),
  getContent: bindActionCreators(businessActions.business.content.get, dispatch),
  getPublishers: bindActionCreators(publisherActions.publishers.get, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ business }) => !business,
    renderNothing
  ),
  lifecycle({
    componentDidMount() {
      const {
        publishers,
        isFetchingPublishers,
        getPublishers,
        getNonCpdContent,
        business,
        getContent
      } = this.props;

      getNonCpdContent(business.id);
      getContent(business.id, 0, { take: 100, status: contentStatus.Published.value })

      if (fp.isEmpty(publishers) && !isFetchingPublishers) {
        getPublishers();
      }
    }
  }),
  withProps(
    ({ user }) => ({
      isBusinessAdmin: isBusinessAdmin(user)
    })
  )
)(BusinessContentHome)


// WEBPACK FOOTER //
// ./src/containers/pages/app/training/business-content-home.js